/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').directive('multiselectDropdown', function (_) {
	return {
		restrict: 'E',
		templateUrl: 'components/visual/multiselect-dropdown/multiselect-dropdown-template.html',
		require: ['ngModel', '?^form'],
		scope: {
			attachToBody: '=',
			btnMinWidth: '=',
			btnMaxWidth: '=',
			clearable: '=',
			collection: '=',
			collectionFilter: '=',
			collectionSortProperty: '=',
			componentDisabled: '=ngDisabled',
            dividersEnabled: '=',
			dropup: '=',
			enableSelectAll: '=',
			ignoreLocks: '=',
			labelField: '@',
			labelFunction: '=',
            lockSelection: '=',
            lockSelectionProp: '@',
            maxHeight: '=',
			modelProp: '@',
            ngChange: '&',
            ngRequired: '<',
            onChange: '<',
            prompt: '@',
            promptFunction: '<',
            sortCollection: '@',
            showdates: '=',
            showLoading: '<',
            valueProp: '@'
        },
		link: function (scope, element, attrs, controllers) {
			var modelController = controllers[0];
            let sortCollection = (scope.sortCollection !== undefined) ? attrs.sortCollection === 'true' : true;
            var form = controllers[1];

			scope.selections = [];
			scope.parentId = attrs.id;
			scope.widthStyle = {};
            scope.loadingIndicator = {
                backdrop: true,
                size: 'sm',
            };

            if (scope.btnMinWidth > 0) {
				scope.widthStyle.minWidth = scope.btnMinWidth + 'px';
			}
			if (scope.btnMaxWidth > 0) {
				scope.widthStyle.maxWidth = scope.btnMaxWidth + 'px';
			}

            scope.$watch(function() {
                return attrs.id;
            }, function (newParentId) {
                scope.parentId = newParentId;
            });

            scope.$watch('dropdown.isopen', function (isOpen, wasOpen) {
                if (wasOpen && !isOpen) {
                    modelController.$setTouched();
                }
            });

			if (!scope.collectionSortProperty) {
				scope.$watch('collection', function (collection) {
					if (collection && collection.length > 1 && scope.labelField && sortCollection) {
						collection.sort(function (a, b) {
							if (a[scope.labelField].toLowerCase() < b[scope.labelField].toLowerCase()) {
								return -1;
							}
							if (a[scope.labelField].toLowerCase() > b[scope.labelField].toLowerCase()) {
								return 1;
							}
							return 0;
						});
					}
				});
			}

            function onRequiredUpdate() {
                scope.selectRequired = attrs.required;
                modelController.$validate();
            }

            scope.$watch('ngRequired', onRequiredUpdate);
            onRequiredUpdate();

			function isClearable() {
				// default to true if undefined
				return angular.isUndefined(scope.clearable) || scope.clearable;
			}

			function getSelectionIndex(candidate) {
                if (scope.valueProp) {
                    if (_.isObjectLike(candidate[scope.valueProp])) {
                        return _.findIndex(scope.selections, candidate[scope.valueProp]);
                    } else {
                        return scope.selections.indexOf(candidate[scope.valueProp]);
                    }
                } else if (candidate.id) {
                    return _.findIndex(scope.selections, { id: candidate.id });
                } else {
                    return scope.selections.indexOf(candidate);
                }
			}

			function getButtonLabel(viewValue) {
				var dateString = '', startYear, endYear;
				if (scope.labelFunction) {
					return scope.labelFunction(viewValue);
				}

				if (scope.showdates && viewValue.hasOwnProperty('startDate') && viewValue.hasOwnProperty('endDate')) {
					startYear = (viewValue.startDate) ? '' + new Date(viewValue.startDate).getUTCFullYear() : '';
					endYear = (viewValue.endDate) ? '' + new Date(viewValue.endDate).getUTCFullYear() : '';
					dateString = (startYear && endYear) ? ' (' + startYear + ' - ' + endYear + ')' : '';
				}
				if (!scope.labelField) {
					return viewValue;
				} else {
					if (viewValue[scope.labelField]) {
						return viewValue[scope.labelField] + dateString;
					} else {
						return scope.prompt || '';
					}

				}
			}

			modelController.$render = function () {
				scope.selections = modelController.$viewValue.selections;
				scope.buttonPrompt = scope.prompt || '';
				if (modelController.$viewValue.selections && modelController.$viewValue.selections.length > 1) {
					scope.buttonPrompt = 'multiple selections';
				} else if (modelController.$viewValue.selections && modelController.$viewValue.selections.length === 1) {
					scope.buttonPrompt = getButtonLabel(modelController.$viewValue.selections[0]);
				}
			};

			modelController.$formatters.push(function (modelValue) {
				var selections = modelValue || [];
				return {selections: selections};
			});

            modelController.$isEmpty = function (viewValue) {
                return _.get(viewValue, 'selections.length', 0) < 1;
            };

			modelController.$parsers.push(function (viewValue) {
				return viewValue.selections;
			});

			scope.dropdownLabelFunction = function (item) {
				if (scope.labelFunction) {
					if (scope.updateButtonPrompt) {
						scope.buttonPrompt = scope.labelFunction(modelController.$modelValue);
						scope.updateButtonPrompt = false;
					}
					return scope.labelFunction(item);
				}
				var dateString = '';
				if (scope.showdates && item.hasOwnProperty('startDate') && item.hasOwnProperty('endDate')) {
					var startYear = (item.startDate) ? '' + new Date(item.startDate).getUTCFullYear() : '';
					var endYear = (item.endDate) ? '' + new Date(item.endDate).getUTCFullYear() : '';
					dateString = (startYear && endYear) ? ' (' + startYear + ' - ' + endYear + ')' : '';
				}
				if (!scope.labelField) {
					return item;
				} else {
					return item[scope.labelField] + dateString;
				}
			};

			scope.idCleaner = function (rawId) {
				return rawId.replace(/ /g, '');
			};

			var updateSelection = function() {
                modelController.$setViewValue({selections: scope.selections});
                modelController.$render();
                modelController.$validate();
                if (typeof(scope.onChange) === 'function') {
                    scope.onChange(modelController.$viewValue.selections);
                }
                if (typeof(scope.ngChange) === 'function') {
                    scope.ngChange();
                }
            };

			var addOptionToSelection = function(option) {
                if (scope.valueProp) {
                    scope.selections.push(option[scope.valueProp]);
                } else {
                    scope.selections.push(option);
                }
                updateSelection();
            };

			scope.toggleOption = function (option, event) {
				if (option.disabled) {
					event.preventDefault();
					event.stopPropagation();
					return;
				}
				if (event.currentTarget && event.currentTarget.tagName !== 'INPUT') {
					event.preventDefault();
				}
				event.stopPropagation();
				event.stopImmediatePropagation();
				var selectionIndex = getSelectionIndex(option);
				if (selectionIndex > -1) {
					scope.selections.splice(selectionIndex, 1);
                    updateSelection();
				} else {
                    addOptionToSelection(option);
				}
				if (form) {
					form.$setDirty();
				}
			};

			scope.isOptionSelected = function (option) {
                var selectionIndex = getSelectionIndex(option);
                if (selectionIndex > -1) {
                    if (option.id && scope.lockSelection && scope.lockSelectionProp && option[scope.lockSelectionProp]) {
                        option.disabled = true;
                    }
                    return true;
                }
                return false;
			};

			scope.toggleDropDown = function (event) {
				event.preventDefault();
				event.stopPropagation();
				scope.dropdown.isopen = !scope.dropdown.isopen;
			};

			scope.toggleAllOptions = function (event) {
				if (event.currentTarget.tagName !== 'INPUT') {
					event.preventDefault();
				}
				event.stopPropagation();
				event.stopImmediatePropagation();
				if (!scope.areAllOptionsSelected()) {
					angular.forEach(scope.collection, function (option) {
						if (!scope.isOptionSelected(option) && !option.disabled) {
                            addOptionToSelection(option);
						}
					});
				} else {
					scope.selections = [];
				}
				updateSelection();
				if (form) {
					form.$setDirty();
				}
			};

			// TODO: Might want to fix this bug: Select All ignores locked options
			scope.areAllOptionsSelected = function () {
				return (scope.selections && scope.selections.length) === (scope.collection && scope.collection.length);
			};

			scope.clearVisible = function () {
				return isClearable() && scope.selections && scope.selections.length > 0;
			};

			scope.clearSelections = function (event) {
				if (isClearable()) {
					event.preventDefault();
					event.stopPropagation();

					if (!scope.componentDisabled) {
						scope.selections.splice(0, scope.selections.length);
					}

					if (form) {
						form.$setDirty();
					}
                    updateSelection();
				}
			};

			var indexFromMenuItem = function (menuItems, item) {
				for (var i = 0; i < menuItems.length; i++) {
					var option = menuItems[i];
					if (item.textContent === option.textContent) {
						return i;
					}
				}
				return -1;
			};

			var getMenuItemPanel = function () {
			    if (scope.attachToBody) {
			        var ulElem = _.find(angular.element(document.body).children(), function (child) {
                        return child.tagName.toLowerCase() === 'ul' && child.style.display === 'block';
                    });
			        return angular.element(ulElem);
                } else {
			        return element.find('ul');
                }
            };

			var optionToSelect = null;
			scope.focusOption = {};
			var currentIndex = -1;
			scope.selectOptionFromKey = function (event) {
				if (scope.dropdown.isopen) {
					var menuItems = getMenuItemPanel().find('li > div > label');
					if (event.keyCode === 38) {
						//up arrow
						event.preventDefault();
						event.stopPropagation();
						if (currentIndex === -1) {
							currentIndex = scope.collection.length;
						}
						while (currentIndex - 1 > -1) {
							optionToSelect = scope.collection[--currentIndex];
							if (scope.ignoreLocks || !optionToSelect.locked) {
								break;
							}
						}
						if (!optionToSelect.locked) {
							scope.focusOption = menuItems[currentIndex];
							scope.focusOption.focus();
						}
						if (currentIndex === 0) {
							currentIndex--;
						}

					} else if (event.keyCode === 32) {
						// Spacebar to change selection status
						scope.toggleOption(scope.collection[currentIndex], event);
						scope.focusOption = {};
					} else if (event.keyCode === 40) {
						//down arrow
						event.preventDefault();
						event.stopPropagation();
						if (currentIndex === scope.collection.length - 1) {
							currentIndex = -1;
						}
						while (currentIndex + 1 < scope.collection.length) {
							optionToSelect = scope.collection[++currentIndex];
							if (scope.ignoreLocks || !optionToSelect.locked) {
								break;
							}
						}
						if (!optionToSelect.locked) {
							scope.focusOption = menuItems[currentIndex];
							scope.focusOption.focus();
						}
					} else if (event.keyCode >= 48 && event.keyCode <= 90) {
						event.preventDefault();
						event.stopPropagation();
						var key = String.fromCharCode(event.keyCode).toLowerCase();
						var filteredMenuItems = menuItems.filter(function (index, item) {
							return item.textContent.charAt(0).toLowerCase() === key && angular.element(item).find('i').length === 0;
						});
						if (scope.focusOption.textContent && scope.focusOption.textContent.charAt(0).toLowerCase() === key && filteredMenuItems.length > 1) {
							var focusedIndex = -1;
							for (var i = 0; i < filteredMenuItems.length; i++) {
								var option = filteredMenuItems[i];
								if (option.textContent === scope.focusOption.textContent) {
									focusedIndex = i;
									break;
								}
							}
							if (focusedIndex + 1 < filteredMenuItems.length) {
								scope.focusOption = filteredMenuItems[focusedIndex + 1];
							} else {
								scope.focusOption = filteredMenuItems[0];
							}
							scope.focusOption.focus();
						} else if (filteredMenuItems.length > 0) {
							scope.focusOption = filteredMenuItems[0];
							scope.focusOption.focus();
						}
						currentIndex = indexFromMenuItem(menuItems, scope.focusOption);
					}
				}
			};
		}
	};
});
